import React, { useState, useEffect } from "react";
import { Box, Text, VStack, Icon, Collapse, Flex } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { primaryAlt, textPrimary, textSecondary } from "../../utils/colors";

const MotionBox = motion(Box);

const MobileMenuList = ({ tabs, closeDrawer }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const matchingIndex = tabs.findIndex(
      (item) =>
        item.hasSubMenu &&
        item.subMenuItems.some((sub) => location.pathname === sub.route)
    );
    setOpenIndex(matchingIndex !== -1 ? matchingIndex : null);
  }, [location.pathname, tabs]);

  const handleToggle = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  const handleNavigate = (route) => {
    if (route) {
      navigate(route);
      closeDrawer?.(); // close the drawer after navigation
    }
  };

  return (
    <VStack spacing={1} align="stretch" px={0} w="100%">
      {tabs.map((item, index) => {
        const isActive = location.pathname === item.route;
        const isSubmenuActive =
          item.hasSubMenu &&
          item.subMenuItems.some((sub) => location.pathname === sub.route);
        const isOpen = openIndex === index;

        // console.log("isActive", isActive);
        // console.log("isOpen", isOpen);
        // console.log("isSubmenuActive", isSubmenuActive);

        return (
          <Box key={item.id}>
            <Flex
              align="center"
              justify="space-between"
              p="1.125rem 1rem"
              bg={isActive || isSubmenuActive ? primaryAlt : "transparent"}
              color={isActive || isSubmenuActive ? "white" : "gray.700"}
              borderTopLeftRadius="1rem"
              borderBottomLeftRadius="1rem"
              _hover={{ bg: "gray.50" }}
              cursor="pointer"
              onClick={() =>
                item.hasSubMenu
                  ? handleToggle(index)
                  : handleNavigate(item.route)
              }
            >
              <Flex align="center">
                <Icon
                  as={() => (
                    <img
                      src={item.icon}
                      alt=""
                      style={{
                        width: 15,
                        marginRight: 10,
                        opacity: isActive || isSubmenuActive ? 1 : 0.7,
                        filter:
                          isSubmenuActive || isActive ? "invert(1)" : "none",
                      }}
                    />
                  )}
                />
                <Text
                  fontWeight="500"
                  color={isActive || isSubmenuActive ? "white" : textSecondary}
                  fontSize="15px"
                >
                  {item.name}
                </Text>
              </Flex>
              {item.hasSubMenu && (
                <motion.div
                  animate={{ rotate: isOpen ? 180 : 0 }}
                  transition={{ duration: 0.2 }}
                >
                  <ChevronDownIcon boxSize={4} />
                </motion.div>
              )}
            </Flex>

            {item.hasSubMenu && (
              <Collapse in={isOpen} animateOpacity>
                <VStack spacing={1} align="start" pl={10} pr={0} pt={2}>
                  {item.subMenuItems.map((sub, subIndex) => {
                    const isSubActive = location.pathname === sub.route;
                    return (
                      <MotionBox
                        key={subIndex}
                        onClick={() => handleNavigate(sub.route)}
                        w="100%"
                        whileHover={{ x: 4 }}
                        transition={{ type: "spring", stiffness: 200 }}
                        cursor={sub.isDisabled ? "not-allowed" : "pointer"}
                        opacity={sub.isDisabled ? 0.4 : 1}
                      >
                        <Text
                          p="1rem 1rem"
                          fontSize="sm"
                          fontWeight="500"
                          bg={isSubActive ? "gray.100" : "transparent"}
                          color={isSubActive ? textPrimary : textSecondary}
                          borderTopLeftRadius="1rem"
                          borderBottomLeftRadius="1rem"
                          w="100%"
                        >
                          {sub.name}
                        </Text>
                      </MotionBox>
                    );
                  })}
                </VStack>
              </Collapse>
            )}
          </Box>
        );
      })}
    </VStack>
  );
};

export default MobileMenuList;
